import React from 'react';
import ReactDOM from 'react-dom/client';
// Design System - Import in order
import './styles/_variables.css';  // CSS variables first
import './styles/_buttons.css';    // Button system
import './styles/_forms.css';      // Form components
import './styles/_cards.css';      // Card components
import './styles/_utilities.css';  // Utility classes
import './index.css';              // Base styles
import App from './App';
import {AuthProvider} from "./context/authcontext";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './i18n/config'; // Initialize i18n

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </AuthProvider>
);

// Register service worker for PWA only in production
if (process.env.NODE_ENV === 'production') {
  // Temporarily disable service worker registration until we fix the build
  serviceWorkerRegistration.unregister();
} else {
  serviceWorkerRegistration.unregister();
}
